import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { MovieLoadingComponent, MovieDetailSkeletonComponent } from '@usheru-hff/ui/movie-detail-page';
import { Movie } from '@usheru-hff/shared/domain';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
/**
 * Component to display the trReasonsToWatch from a movie.
 */
@Component({
  selector: 'ush-movie-reasons-to-watch',
  templateUrl: './movie-reasons-to-watch.component.html',
  styleUrls: ['./movie-reasons-to-watch.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedUtilsModule, MovieDetailSkeletonComponent]
})
export class MovieReasonsToWatchComponent implements MovieLoadingComponent {
  /**
   * @docsNotRequired
   */
  readonly movie = input<Movie | null>(null);
  readonly isLoadingData = input(false);
}
